import { element } from 'protractor';
import { ByProductOrderConfirmComponent } from './../by-product-order-confirm/by-product-order-confirm.component';
import { MatDialog, ProgressSpinnerMode, ThemePalette } from '@angular/material';
import { Component, OnInit } from '@angular/core';
import { HttpService } from '../../http.service';
import { CashReceiptPreviewComponent } from '../cash-receipt-preview/cash-receipt-preview.component';
@Component({
  selector: 'app-by-product-order',
  templateUrl: './by-product-order.component.html',
  styleUrls: ['./by-product-order.component.scss']
})
export class ByProductOrderComponent implements OnInit {
  is_counter_selected = false;
  counter_list: any;
  collection_center: any;
  logged_user_befere_select_counter: any;
  is_business_selected = false;
  selected_business_code = null;
  sale_group_data: any;
  login_users: any;
  total_amount_in_counter: any;
  counter_name: any;
  total_booth_count: any;
  today_date_time: Date;
  booth_details: any = null;
  final_price = 0;
  final_price_before_rounded = 0;
  product_availablity_dict: any;
  product_price_dict: any;
  selected_product_list = [];
  sale_closed_product_list = [];
  all_product_list = [];
  by_product_group_list: any;
  by_product_dict: any;
  opened_group_index = 0;
  show_next_page = false;
  is_data_available: boolean = true;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  search_code = null;
  roundoff_value = 0;
  is_previous_sale_closed = true;
  is_today_sale_closed = false;
  previous_date = null;
  today_date_from_server = null;
  today_sale_close_details = null;

  constructor(private httpService: HttpService, private dialog: MatDialog) {
    this.today_date_time = new Date();
    this.serveDailyCloseStatus();

  }

  saleClosedCalled(date = Date) {
    if (confirm('Are you sure want to close the sale')) {
      let data_dict = {
        'date': date
      }
      this.httpService.closeSale(data_dict).subscribe((data) => {
        console.log(data);
        this.serveDailyCloseStatus();
      }, (error) => {
        console.error(error);
      });
    }
  }

  serveDailyCloseStatus() {
    this.httpService.serveDailyCloseStatus().subscribe((data) => {
      console.log(data);
      this.is_previous_sale_closed = data['is_previous_sale_closed'];
      this.is_today_sale_closed = data['is_today_sale_closed'];
      this.previous_date = data['previous_date'];
      this.today_date_from_server = data['today_date'];
      this.today_sale_close_details = data['today_sale_close_details'];
      if (this.is_previous_sale_closed && !this.is_today_sale_closed) {
        this.serveUnActiveCounter()
      }
    }, (error) => {
      console.error(error);
    });
  }
  serveUnActiveCounter() {
    this.httpService.serveUnActiveCounter().subscribe((data) => {
      console.log(data);
      if (data === 'counter already selected') {
        this.is_counter_selected = true;
        setTimeout(() => document.getElementById('booth_number').focus(), 500);
        this.serveCounterOrders();
      } else {
        this.counter_list = data['counter_data'];
        this.collection_center = Object.keys(this.counter_list);
        this.logged_user_befere_select_counter = data['logged_users'];
      }
    }, (error) => {
      console.error(error);
    });
  }

  counterClicked(counter_id) {
    let data_dict = {
      'counter_id': counter_id
    };
    this.httpService.assignCounterToEmployee(data_dict).subscribe((data) => {
      console.log(data);
      if (!data['is_taken']) {
        this.is_counter_selected = true;
        setTimeout(() => document.getElementById('booth_number').focus(), 500);
        this.serveCounterOrders();
        // this.serveLastMonthOrderCount();
      } else {
        alert('Selected counter is already taken by' + data['taken_by']);
        return false;
      }
    }, (error) => {
      this.is_counter_selected = false;
      console.error(error);
    });
  }

  getBusinessDetailsAndProduct() {
    console.log(this.selected_business_code);
    if (this.selected_business_code == null || this.selected_business_code === '') {
      alert('Please enter a booth code to Search for');
      return false;
    }
    this.show_next_page = false;
    let data_dict = {
      'business_code': this.selected_business_code
    };
    this.httpService.serveBusinessDetailsForByProduct(data_dict).subscribe((data) => {
      console.log(data);
      this.booth_details = data;
      this.is_business_selected = true;
      this.final_price = 0;
      this.serveProductList();
      this.serveProductPrice();
    }, (error) => {
      this.is_business_selected = false;
      this.selected_business_code = null;
      console.log(error);
      alert(error['error']['error_message']);
    });
  }

  deleteSaleClicked(sale_group_id) {
    if (confirm('Are you sure want to delete')) {
      let data_dict = {
        'id': sale_group_id
      };
      this.httpService.deleteSelectedSale(data_dict).subscribe((data) => {
        console.log(data);
        alert('Delete Successfully')
        this.getBusinessDetailsAndProduct();
        this.serveCounterOrders()
      }, (error) => {
        alert('error while deleteing')
        console.error(error);
      });
    }
  }

  serveCounterOrders() {
    this.httpService.serveCounterOrdersForByProduct().subscribe((data) => {
      console.log(data);
      this.sale_group_data = data['sale_data'];
      this.login_users = data['login_users'];
      this.total_amount_in_counter = data['total_quantity'];
      this.counter_name = this.login_users[0]['counter_name'];
      this.total_booth_count = data['total_booth_count'];
    }, (error) => {
      console.error(error);
    });
  }

  serveProductList() {
    let data_dict = {
      'business_code': this.selected_business_code,
      'from': 'portal'
    };
    this.httpService.serveByProductListForOrder(data_dict).subscribe((data) => {
      console.log(data);
      this.by_product_group_list = data['by_product_group_list'];
      this.by_product_dict = data['by_product_group_dict'];
      this.selected_product_list = data['selected_product_list'];
      this.sale_closed_product_list = data['sale_closed_product_list'];
      this.all_product_list = data['all_product_list'];
    }, (error) => {
      console.error(error);
    });
  }

  serveProductPrice() {
    let data_dict = {
      'business_code': this.selected_business_code,
      'from': 'portal'
    };
    this.is_data_available = false;
    this.httpService.serveByProductAvailabiltyAndPriceList(data_dict).subscribe((data) => {
      this.product_availablity_dict = data['product_availablity_dict'];
      this.product_price_dict = data['product_price_dict'];
      console.log(data);
      this.is_data_available = true;
    }, (error) => {
      this.is_data_available = true;
      console.error(error);
    });
  }

  removeCalled(product_index, product_group_id, product_id) {
    let product_list = this.by_product_dict[product_group_id];
    let main_product_index = product_list
      .map((element) => {
        return element.product_id;
      })
      .indexOf(product_id);
    this.by_product_dict[product_group_id][main_product_index]['is_checked'] = false;
    this.selected_product_list.splice(product_index, 1);
  }

  formExpandClicked(product_group_index) {
    if (this.opened_group_index == product_group_index) {
      this.opened_group_index = null;
    } else {
      this.opened_group_index = product_group_index;
    }
  }

  productCodeSearch() {
    console.log(this.search_code);
    let product_index = this.all_product_list.map((element) => {
      return element.product_code;
    }).indexOf(this.search_code);

    let product_index_in_selected_product_index = this.selected_product_list.map((element) => {
      return element.product_code;
    }).indexOf(this.search_code);

    if (product_index_in_selected_product_index != -1) {
      alert('This product is already in list');
      return false;
    }
    if (product_index == -1) {
      alert('Product not available');
    } else if (this.all_product_list[product_index]['is_checked']) {
      alert('This product is already added');
      return false;
    } else if (this.all_product_list[product_index]['quantity_now'] <= 0) {
      alert('Quantity not available in given product');
      return false;
    } else {
      let product = this.all_product_list[product_index];
      let product_group = product['product_group']
      let product_index_from_product_group_dict = this.by_product_dict[product_group].map((element) => {
        return element.product_code;
      }).indexOf(this.search_code);
      if (product['entered_qty'] === 0) {
        product['entered_qty'] = null;
      }
      this.selected_product_list.push(product);
      this.by_product_dict[product_group][product_index_from_product_group_dict]['is_checked'] = true;
    }
    this.search_code = null;
    console.log(this.all_product_list[product_index]);
  }

  addOrRemoveCalled(action_for, product_dict, product_index) {
    console.log('event called');
    let selected_product_index = product_index;
    console.log(this.by_product_dict[product_dict['product_group']][selected_product_index]);
    if (action_for === 'add') {
      this.by_product_dict[product_dict['product_group']][selected_product_index]['is_checked'] = true;
      this.selected_product_list.push(product_dict);
    } else {
      this.by_product_dict[product_dict['product_group']][selected_product_index]['is_checked'] = false;
      let product_index = this.selected_product_list.map((element) => {
        return element.product_id;
      }).indexOf(product_dict['product_id']);
      console.log(product_index);
      this.selected_product_list.splice(product_index, 1);
    }
    console.log(this.selected_product_list);
  }

  productListingPage() {
    this.show_next_page = true;
    this.selected_product_list.forEach(element => {
      if (element.entered_qty === 0) {
        element.entered_qty = null;
      }
    });
    this.final_price = 0;
    this.selected_product_list.forEach(element => {
      this.final_price += element.price;
    });
  }


  backToProductSelectPage() {
    this.show_next_page = false;
  }

  calculateGST(product_id, price) {
    let cgst_value = this.product_price_dict[product_id]['cgst_percent'];
    let sgst_value = this.product_price_dict[product_id]['sgst_percent'];

    let product_cgst_value = (cgst_value / 100) * price;
    let product_sgst_value = (sgst_value / 100) * price;
    let data_dict = {
      'product_cgst_value': product_cgst_value,
      'product_sgst_value': product_sgst_value
    }
    return data_dict
  }

  productQuantityChanged(product_index) {
    const numbers = /^[0-9\s]*$/;
    let product_dict = this.selected_product_list[product_index];
    let available_qty = this.product_availablity_dict[product_dict['product_id']]['quantity_now'];
    if (product_dict['entered_qty'] > available_qty) {
      alert('Product Qty Exceed!');
      this.selected_product_list[product_index]['entered_qty'] = null;
    }
    if (this.selected_product_list[product_index]['entered_qty'] != null) {
      if (numbers.test(product_dict['entered_qty']) === false) {
        alert('Invalid Number');
        this.selected_product_list[product_index]['entered_qty'] = null;
      }
    }
    //
    let value = product_dict['entered_qty'] * this.product_price_dict[product_dict['product_id']]['base_price'];
    let total_price = product_dict['entered_qty'] * this.product_price_dict[product_dict['product_id']]['mrp'];
    let total_gst = total_price - value;

    let cgst_value = total_gst / 2;
    let sgst_value = total_gst / 2;
    this.final_price_before_rounded = 0;
    this.selected_product_list[product_index]['value'] = value;
    this.selected_product_list[product_index]['cgst_value'] = cgst_value;
    this.selected_product_list[product_index]['sgst_value'] = sgst_value;
    this.selected_product_list[product_index]['total_price'] = total_price;
    this.selected_product_list.forEach(element => {
      this.final_price_before_rounded += element.total_price;
    });
    let rounded_value = Math.ceil(this.final_price_before_rounded);
    this.roundoff_value = 0;
    this.roundoff_value = rounded_value - this.final_price_before_rounded
    this.final_price = rounded_value;
  }

  confirmOrder() {
    document.getElementById('confirm_button').blur();
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    console.log('dialog open');
    const dialogRef = this.dialog.open(ByProductOrderConfirmComponent, {
      height: '394px',
      width: '600px',
      data: {
        'product_list': this.selected_product_list,
        'final_price': this.final_price,
        'roundoff_value': this.roundoff_value,
        'final_price_before_rounded': this.final_price_before_rounded,
        'business_code': this.selected_business_code
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      const res = result;
      if (res) {
        if (res.hasOwnProperty('data')) {
          this.cashReceiptPreview(res['data']);
        }
        this.serveCounterOrders();
        this.clearFormIsCalled();
      }
    });
  }



  cashReceiptPreview(document) {
    const dialogRef = this.dialog.open(CashReceiptPreviewComponent, {
      height: '700px',
      width: '700px',
      data: document,
      // disableClose: true,
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      this.clearFormIsCalled();
    });
  }

  clearFormIsCalled() {
    this.final_price = null;
    this.selected_business_code = null;
    this.is_business_selected = false;
    this.product_availablity_dict = {};
    this.product_price_dict = {};
    this.selected_product_list = [];
    this.by_product_group_list = [];
    this.by_product_dict = {};
    window.scrollTo(0, 0);
    this.show_next_page = false;
    setTimeout(() => document.getElementById('booth_number').focus(), 500);

  }

  ngOnInit() {
  }

}
